import React, {Component} from 'react';
import {Col, FormGroup, Label, Input} from 'reactstrap';
class FormSelect extends Component {
	render() {
		if (this.props.valueArray && this.props.valueArray.length > 0) {
			let displayLabel = this.props.humanLabel;
			if (this.props.dbView) {
				displayLabel = `${this.props.parentID.split('-')[0]}.${this.props.label}`;
			}
			let options = [];
			this.props.valueArray.forEach((option, i) => {
				if (i === 0) {
					options.push(
						<option key="0" value="0">
							No Selection
						</option>
					);
				}

				options.push(
					<option key={i + 1} value={option.id}>
						{option.value}
					</option>
				);
			});

			return (
				<Col xs={this.props.colsize}>
					<FormGroup>
						<Label
							className="simpleLabel"
							for={`${this.props.parentID}-${this.props.label}`}
						>
							{displayLabel}{' '}
						</Label>
						<Input
							id={`${this.props.parentID}-${this.props.label}`}
							className="rounded-0 textinput"
							type="select"
							onChange={(event) => {
								if (event.target.value == 0) {
									// event.target.value = '';
									let fakeEvent = {
										target: {
											id:    event.target.id,
											value: ''
										}
									};

									return this.props.triggerFormValueChange(fakeEvent);
								}
								this.props.triggerFormValueChange(event);
							}}
							value={this.props.currentValue}
							disabled={this.props.isDisabled}
						>
							{options}
						</Input>
					</FormGroup>
				</Col>
			);
		}

		return (
			<Col xs={this.props.colsize}>
				<p>Should have been a dropdown but no options were presented.</p>
			</Col>
		);
	}
}

export default FormSelect;



// WEBPACK FOOTER //
// ./src/components/FormSelect.js